<script setup lang="ts">
import lodashPick from 'lodash-es/pick';

export interface StoryblokImageProps {
    blok: StoryblokImage;
}

// PROPS
const { blok } = defineProps<StoryblokImageProps>();

// COMPOSABLES
const { classes } = useStoryblokComponentClass(() => lodashPick(blok, ['maxWidth', 'aspectRatio', 'rounded']));

// DATA
const asset = computed<StoryblokAsset>(() => blok.asset);
</script>

<template>
    <NuxtImg
        v-if="!!asset.filename"
        v-editable="blok"
        format="webp"
        class="mx-auto w-full"
        :class="classes"
        draggable="false"
        :loading="blok.loading"
        provider="storyblok"
        :src="asset.filename"
        :alt="asset.alt ?? ''"
        :width="blok.width"
        :height="blok.height"
    />
</template>
